document.querySelectorAll('.bildhero .images').forEach(w=>{
	let imgs=[...w.querySelectorAll('img')],i=0
	if(imgs.length<2)return
	imgs.forEach((im,n)=>{im.style.cssText='opacity:'+(n?0:1)+';transition:opacity 1200ms;z-index:'+(n?1:2)})
	setInterval(()=>{
		let a=imgs[i],b=imgs[i=(i+1)%imgs.length]
		b.style.zIndex=3;b.style.opacity=1
		setTimeout(()=>{a.style.opacity=0;a.style.zIndex=1;b.style.zIndex=2},50)
	},6500)
})